import React, { Component, Fragment } from 'react';
import SchoolDropdown from './SchoolDropdown';
import MenuOptions from './../../Misc/MenuOptions/menuOptions';
import { getCatererMenuOptions } from './../../Misc/MenuOptions/menuOptionsActions';
import {access_token} from '../../../server/constants'
import ReactTooltip from 'react-tooltip'
class FilterBar extends Component {
    render() {
        return (
            <div className="container bg-color-4" style={{ marginTop: '10px', marginBottom: '10px', padding: '5px', borderRadius: '3px' }}>
                <div className="row ">
                    <div className="col-xs-4">{
                        this.props.showSchoolsDropdown?
                        <SchoolDropdown {...this.props} />:null}
                    </div>
                    <div className="col-xs-4">
                        {this.props.hideMealType?null:
                              <MenuOptions
                            menuOptionsList={getCatererMenuOptions()}
                            onOptionSelect={(type) => {
                                this.props.onMenuTypeChange(type);
                            }}
                            selectedOption={this.props.mealType} />
                        }
                    </div>
                    <div className="col-xs-4 text-right">
                        {
                           this.props.showSchoolOpen===false?null: ((this.props.selectSchool||'0')==='0' || (this.props.selectSchool||'')==='')?
                            null:<Fragment>
                            <button className="btn btn-primary" style={{ margin:'0px 0px 0px 3px', fontSize: '12px'}} onClick={()=>{
                                const schoollist=this.props.schoolList||[]
                                const selectedSchool=schoollist.find((school)=>{
                                    return school.schoolId==this.props.selectSchool
                                })
                                if(selectedSchool){
                                    const protocal = window.location.protocol;
                                    const mainDomain =window.location.host.replace(window.location.host.split('.')[0],'');
                                    const subdomain=selectedSchool.subdomain;
                                    const refresh_token = sessionStorage.getItem('refresh_token')||'';
                                    const url=`${protocal+'//'+ subdomain + mainDomain}?${btoa(`akey=${access_token()}&rkey=${refresh_token}`)}`
                                    window.open( url, '_blank' // <- This is what makes it open in a new window.
                                                      );
                                }
                            }} data-tip data-for={'tooltip-adminview'}><i className="fa fa-external-link"></i></button>
                            <ReactTooltip id={'tooltip-adminview'} aria-haspopup='true' type="dark" effect="float">
                            <div>
                            {'Click here for login to school'}
                            </div>
                            </ReactTooltip>
                            </Fragment>


                        }
                        
                    </div>
                </div>
            </div>
        );
    }
}
export default FilterBar;


// WEBPACK FOOTER //
// ./src/components/Caterer/Home/FilterBar.jsx